// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"a3995f60","741":"ab794915"}[chunkId] + ".chunk.js";
};